import theme from 'styled-theming';
var getPrimaryAppearance = theme('mode', {
  light: 'var(--primaryOrange)',
  dark: 'var(--dark-tempColor)'
});
var getSecondaryAppearance = theme('mode', {
  light: 'var(--grey70)',
  dark: 'var(--dark-tempColor)'
});
var getTertiaryAppearance = theme('mode', {
  light: 'var(--white)',
  dark: 'var(--dark-tempColor)'
});
var getDestructiveAppearance = theme('mode', {
  light: 'var(--danger)',
  dark: 'var(--dark-tempColor)'
});
var getGhostAppearance = theme('mode', {
  light: 'var(--white)',
  dark: 'var(--dark-tempColor)'
});
var getTransparentAppearance = theme('mode', {
  light: 'var(--transparent)',
  dark: 'var(--dark-tempColor)'
});
var getDisabledBackgroundAppearance = theme('mode', {
  light: 'var(--grey10)',
  dark: 'var(--dark-tempColor)'
});
var getDisabledTextAppearance = theme('mode', {
  light: 'var(--grey50)',
  dark: 'var(--dark-tempColor)'
});
export default {
  getPrimaryAppearance: getPrimaryAppearance,
  getSecondaryAppearance: getSecondaryAppearance,
  getTertiaryAppearance: getTertiaryAppearance,
  getDestructiveAppearance: getDestructiveAppearance,
  getGhostAppearance: getGhostAppearance,
  getTransparentAppearance: getTransparentAppearance,
  getDisabledBackgroundAppearance: getDisabledBackgroundAppearance,
  getDisabledTextAppearance: getDisabledTextAppearance
};